import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#198FA9',
        secondary: '#1A3D6D',
        toolbar: '#384041',
        grey: '#7F7F7F',
        lightgrey: '#F7F7F7',
        tertiary: '#4DBD92',
        red: '#D65060',
        warning: '#F29B53'
      },
      dark: {
        primary: '#198FA9',
        secondary: '#1A3D6D',
        toolbar: '#384041',
        grey: '#7F7F7F',
        lightgrey: '#F7F7F7',
        tertiary: '#4DBD92',
        red: '#D65060',
        warning: '#F29B53'
      }
    },
  },
  icons: {
    iconfont: 'md',
  },
});
